/* eslint-disable */
const TABS_STATE = {
	previewDocId: '',
	activeTab: 1,
	previewHeadline: '',
	previewsubject: ''
};
export default TABS_STATE;
